
export const dataTab = {
    "query": {
        "id": "BANK_CARDS_UI_V",
        "source": "BANK_CARDS_UI_V",
        "context": "userFilialFilterContextStrategy",
        "fields": [
            {   "column": "id", },
            {   "column": "bank_contract_id",  },
            {   "column": "card_id",  },
            {   "column": "sign_primary",  },
            {   "column": "card_number", },
            {   "column": "card_account",  },
            {   "column": "date_expire",  },
            {   "column": "embossed_name",  },
            {   "column": "card_state_id", },
            {   "column": "is_registered", },
            {   "column": "state_code", },
            {   "column": "date_registered", },
            {   "column": "card_product_code", },
            {   "column": "card_application_id", },
            {   "column": "person_id", },
            {   "column": "created_at", },
            {   "column": "created_by", },
            {   "column": "modified_at", },
            {   "column": "modified_by", },
            {   "column": "contract_id", },
            {   "column": "filial", },
        ],
        "orderBy":[
            {
                "column":"date_registered",
                "direction":"desc"
            }
        ],
    }
};

export const columns = (t) => [
    {
        title: t('id'),
        dataIndex: 'id',
        width: 60,
//        defaultSortOrder: 'descend',
        sorter: (a, b) => a.id - b.id,
    },
    {
        title: t('bankContractId'),
        dataIndex: 'bank_contract_id',
        width: 60,
        sorter: (a, b) => a.bank_contract_id - b.bank_contract_id,
    },
    {
        title: t('cardId'),
        dataIndex: 'card_id',
        width: 60,
        sorter: (a, b) => a.card_id - b.card_id,
    },
    {
        title: t('signPrimary'),
        dataIndex: 'sign_primary',
        width: 60,
        sorter: (a, b) => a.sign_primary - b.sign_primary,
    },
    {
        title: t('cardNumber'),
        dataIndex: 'card_number',
        width: 70,
        sorter: (a, b) => a.card_number - b.card_number,
    },
    {
        title: t('cardAccount'),
        dataIndex: 'card_account',
        width: 50,
        sorter: (a, b) => a.card_account - b.card_account,
    },
    {
        title: t('dateExpire'),
        dataIndex: 'date_expire',
        width: 100,
        sorter: (a, b) => new Date(a.date_expire.split('.').reverse().join('-')) - new Date(b.date_expire.split('.').reverse().join('-')),
    },
    {
        title: t('embossedName'),
        dataIndex: 'embossed_name',
        width: 50,
        sorter: (a, b) => a.embossed_name - b.embossed_name,
    },
    {
        title: t('cardStateId'),
        dataIndex: 'card_state_id',
        width: 50,
        sorter: (a, b) => a.card_state_id - b.card_state_id,
    },
    {
        title: t('isRegistered'),
        dataIndex: 'is_registered',
        width: 50,
        sorter: (a, b) => a.is_registered - b.is_registered,
    },
    {
        title: t('stateCode'),
        dataIndex: 'state_code',
        width: 50,
        sorter: (a, b) => a.state_code - b.state_code,
    },
    {
        title: t('dateRegistered'),
        dataIndex: 'date_registered',
        width: 50,
        sorter: (a, b) => new Date(a.date_registered.split('.').reverse().join('-')) - new Date(b.date_registered.split('.').reverse().join('-')),
    },
    {
        title: t('cardProductCode'),
        dataIndex: 'card_product_code',
        width: 50,
        sorter: (a, b) => a.card_product_code - b.card_product_code,
    },
    {
        title: t('cardApplicationId'),
        dataIndex: 'card_application_id',
        width: 50,
        sorter: (a, b) => a.card_application_id - b.card_application_id,
    },
    {
        title: t('personId'),
        dataIndex: 'person_id',
        width: 50,
        sorter: (a, b) => a.person_id - b.person_id,
    },
    {
        title: t('contractId'),
        dataIndex: 'contract_id',
        width: 50,
        sorter: (a, b) => a.contract_id - b.contract_id,
    },
    {
        title: t('filial'),
        dataIndex: 'filial',
        width: 50,
        sorter: (a, b) => a.filial - b.filial,
    },
    {
        title: t('createdDate'),
        dataIndex: 'created_at',
        hidden: true
    },
    {
        title: t('createdBy'),
        dataIndex: 'created_by',
        hidden: true
    },
    {
        title: t('modifiedDate'),
        dataIndex: 'modified_at',
        hidden: true
    },
    {
        title: t('modifiedBy'),
        dataIndex: 'modified_by',
        hidden: true
    },

];

export const columnsCardUser = (t) => [

        {
            title: t('id'),
            dataIndex: 'id',
            width: 60,
            hidden: true,
//             /sorter: (a, b) => a.id - b.id,
        },
        {
            title: t('embossedName'),
            dataIndex: 'embossed_name',
            width: 120,
            sorter: (a, b) => a.bank_contract_id - b.bank_contract_id,
            //...useColumnSearchProps('embossed_name')
        },
        {
            title: t('cardNumber'),
            dataIndex: 'card_number',
            width: 80,
            sorter: (a, b) => a.card_number - b.card_number,
        },
       /* {
            title: t('sumPay'),
            dataIndex: 'sumpay',
            width: 60,

        },*/
        {
            title: t('dateExpire'),
            dataIndex: 'date_expire',
            width: 60,
            sorter: (a, b) => new Date(a.date_expire.split('.').reverse().join('-')) - new Date(b.date_expire.split('.').reverse().join('-')),
        }
]

export const dataFilter = [
    { "column": "id", "label": "ИД", "operator": "=", "datatype":"number"},
    { "column": "filial", "label": "Филиал", "operator": "in", "datatype":"text", "type":"M","typeRef":"FILIAL"},
    { "column": "card_account", "label": "Туловчи Х.Р.", "operator": "_like_", "datatype":"text"},
]